import Language from '@opsbase/lib-i18n/Language';
import useOpDefinitionUpdate from '@opsbase/react-gql-hooks/opdefinition/useOpDefinitionUpdate';
import FormEditor from '@opsbase/web-opform-editor';
import React, { useCallback, useMemo } from 'react';
export function OpDefinitionEditFormTab(props) {
    const { opDefinition, language = Language.ENGLISH, isEditable } = props;
    const { mode = 'edit' } = props;
    const updateOpDefinition = useOpDefinitionUpdate();
    const editorMode = !isEditable ? 'view' : mode;
    const handleChangeForm = useCallback(async (form) => 
    // Fire and forget changes
    updateOpDefinition({
        id: opDefinition.id,
        patch: { form },
    }), [opDefinition.id, updateOpDefinition]);
    return useMemo(() => (React.createElement(FormEditor, { mode: editorMode, id: opDefinition.id, title: opDefinition.title, form: opDefinition.form, canAllQuestionsBeSkipped: opDefinition.canAllQuestionsBeSkipped, formConstraints: opDefinition.formConstraints, isScoreEnabled: opDefinition.isScoreEnabled, isScorePublic: opDefinition.isScorePublic, isGradingPublic: opDefinition.isGradingPublic, allowIssuesAndNotes: opDefinition.allowIssuesAndNotes, gradingMethod: opDefinition.gradingMethod, onChangeForm: handleChangeForm })), 
    // Importantly, the FormEditor is only loaded ONCE
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [opDefinition.id, language]);
}
export default OpDefinitionEditFormTab;
